<template>
    <div>
        <v-container>
            <div class="d-flex justify-space-between mt-10 mb-5">
                <h2 class="mb-3">Users</h2>
            </div>

            <v-text-field v-model="searchText"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          class="mb-3"
                          hide-details></v-text-field>

            <v-data-table :headers="headers"
                          :items="users"
                          must-sort
                          item-key="key"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :server-items-length="totalItems"
                          :loading="isBusy"
                          :items-per-page.sync="pageSize"
                          :footer-props="{'items-per-page-options': [25, 50, 100, 100]}"
                          :page.sync="pageNo"
                          class="elevation-1">

                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text icon v-bind="attrs"
                                   @click="onOpenUserOperatorModal(item.operatorName, item.id)"
                                   v-on="on" color="lighten-2">
                                <v-icon>mdi-account-reactivate</v-icon>
                            </v-btn>
                        </template>
                        <span>Change User Operator</span>
                    </v-tooltip>

                </template>

                <template v-slot:item.dateRegistered="{ item }">
                    {{ item.dateRegistered | DateTime }}
                </template>

            </v-data-table>
        </v-container>

        <sweet-modal :modal-theme="$vuetify.theme.dark === true ? 'dark' : 'light'" :overlay-theme="$vuetify.theme.dark === true ? 'light' : 'dark'" ref="updateUserOperatorModal" blocking>
            <v-form v-model="isFormValid" ref="userOperatorForm">
                <v-container>
                    <h3 class="mb-3">
                        Update User Operator
                    </h3>
                
                    <v-row>
                        <v-col cols="12">
                            <v-select :items="operators"
                                      item-text="name"
                                      item-value="id"
                                      v-model="selectedOperator"
                                      label="Select Operator"></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" align="right">
                            <v-btn depressed
                                   @click="updateUserOperator"
                                   :disabled="!isFormValid"
                                   align="right"
                                   class="black--text mt-10 font-bold"
                                   color="primary">
                                Save
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </sweet-modal>

    </div>
</template>
<script>
    import UserService from "../../services/userService.js"
    import OperatorService from "../../services/operatorService.js"
    export default {
        name: 'Users',
        components: {
          
        },
        data: function () {
            return {
                isBusy: true,
                email: "",
                searchTimer: null,
                searchText: "",
                pageNo: 1,
                pageSize: 10,
                accessToken: "",
                totalItems: 0,
                sortBy: 'id',
                sortDesc: false,
                headers: [
                    {
                        text: 'Email',
                        align: 'start',
                        sortable: true,
                        value: 'id',
                    },
                    {
                        text: 'Date Registered',
                        align: 'start',
                        sortable: true,
                        value: 'dateRegistered',
                    },
                    {
                        text: 'Operator',
                        align: 'start',
                        sortable: true,
                        value: 'operatorName',
                    },
                    { text: '', value: 'actions', align: 'end', sortable: false },
                ],
                users: [],
                operators: [],
                isFormValid: false,
                selectedOperator: null,
                selectedUserId: ""
            }
        },
        watch: {
            pageNo: function () {
                this.searchUsers();
            },
            pageSize: function () {
                this.searchUsers();
            },
            searchText: function () {
                let self = this;
                clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(function () {
                    self.searchUsers();
                }, 1000);
            },
            sortBy: function () {
                this.searchUsers();
            },
            sortDesc: function () {
                this.searchUsers();
            }
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();
                await this.searchUsers();
                await this.getOperators();
            },
            async searchUsers() {
                this.isBusy = true;
                var sortBy = this.sortBy ? "id" : this.sortBy;
                var sortDesc =  this.sortDesc === false ? "ASCENDING" : "DESCENDING"
                const result = await UserService.searchUsers(this.accessToken, this.searchText, this.pageNo, this.pageSize, sortBy, sortDesc);
                this.users = result.data.map((item, key) => ({ ...item, key }));
                this.totalItems = result.count;
                this.isBusy = false;
            },
            async updateUserOperator() {
                this.isBusy = true;

                const request = {
                    userId: this.selectedUserId,
                    operatorId: this.selectedOperator
                };

                let result = await UserService.updateUser(request, this.accessToken);

                this.isBusy = false;

                if (result) {
                    this.$refs.updateUserOperatorModal.close();
                    this.selectedOperator = null;
                    this.selectedUserId = "";
                    await this.searchUsers();
                }
            },
            async getOperators() {
                this.isBusy = true;
                let result = await OperatorService.searchOperators(this.accessToken, "", 1, 100, "name", "ASCENDING");
                this.operators = result.data;
                this.isBusy = false;
            },
            onOpenUserOperatorModal(operatorName, userId) {
                this.isBusy = true;
                this.selectedUserId = userId;

                const operator = this.operators.find((operator) => operator.name === operatorName);
                if (operator) {
                    this.selectedOperator = operator.id;
                }
               
                this.$refs.updateUserOperatorModal.open();
                this.isBusy = false;
            }
        },
        created() {
            this.setup();
        }
    }
</script>
